import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useUserStore } from '@/stores/user'
import useField from '@/composables/useField'
import { useConfirm } from '@/composables/useConfirm'
import { useModalOpener } from '@/composables/useModalOpener'
import {
  lpCreateResource,
  lpUpdateResource,
} from '@/services/lps.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'LPCreateModal',
  props: {
  promise: Promise,
  close: Function,
  info: Object,
},
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const store = useUserStore()
const currentResource = ref(props.info ? lpUpdateResource : lpCreateResource)
const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)

const form = ref({
  id: '',
  name: '',
  organizationName: '',
  email: '',
  stringName: '',
  status: '',
  isActive: false,
})

const statusOptions = ref([
  {isActive: true, title: $t('Active')},
  {isActive: false, title: $t('Inactive')}
])

watch(() => props.info, () => {
  if(props.info) {
    Object.keys(form.value).forEach(key => {
      if(props.info[key]) form.value[key] = props.info[key]
    })
    form.value.status = props.info.isActive ? statusOptions.value[0] : statusOptions.value[1]
  }
}, {immediate: true, deep: true})

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const fields = ref([
  useField('name', $t('LP ID (Name)'), { rules: 'min:2|max:255' }),
  useField('stringName', $t('LP string names'), { rules: 'min:2|max:255', description: $t('Separate by comma'), }),
  useField('organizationName', $t('Organization Name (optional)'), { rules: 'min:2|max:255' }),
  useField('email', $t('Email'), { rules: 'min:2|max:255' }),
  useField('status', $t('Status'), {
    component: 'd-control-multiselect',
    options: statusOptions.value,
    'show-labels': false,
    'track-by': 'isActive',
    'label-by': 'title',
    'allow-empty': false,
    // multiple: true,
    condition: () => props.info
  }),
])

const send = async (sendData: any, control: any) => {
  const preparedData = {
    ...sendData,
  }
  const question = $t('Сonfirm action')
  const title = $t('Successfully')
  const subtitle = props.info ? $t('All data is saved') : $t('A new LP is created')
  if(props.info) preparedData.isActive = sendData.status.isActive
  try {
      await useConfirm(question)
      load.value = true
      const { redirectLink } = (await currentResource.value.execute({id: form.value.id}, {
        ...preparedData,
      }))
      dataIsSended.value = true
      load.value = false
      await useModalOpener({
      component: 'UiMessageModal',
      message:{
        title,
        subtitle,
        success: true,
        },
      })
      props.promise(true)
      props.close()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { props, store, currentResource, emit, $t, load, dataIsSended, form, statusOptions, request, fields, send, ref, watch, get useSubmit() { return useSubmit }, get useUserStore() { return useUserStore }, get useField() { return useField }, get useConfirm() { return useConfirm }, get useModalOpener() { return useModalOpener }, get lpCreateResource() { return lpCreateResource }, get lpUpdateResource() { return lpUpdateResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})